/**
 * API configuration for admin frontend
 */

const url = import.meta.env.VITE_API_URL as string | undefined;

if (!url) {
  throw new Error('VITE_API_URL environment variable is required');
}

// Ensure the URL ends with a slash
const normalizedUrl: string = url.endsWith('/') ? url : url + '/';

export const API_BASE_URL: URL = new URL(normalizedUrl);
